import { render, staticRenderFns } from "./NewNavbar.vue?vue&type=template&id=348d2ab4&"
import script from "./NewNavbar.vue?vue&type=script&lang=js&"
export * from "./NewNavbar.vue?vue&type=script&lang=js&"
import style0 from "./NewNavbar.vue?vue&type=style&index=0&id=348d2ab4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports